import { createGTMScriptTag, GTM_SCRIPT_ID } from "./gtm-script";

let gtmPromise: Promise<void>;

export const loadGTM = () => {
  if (gtmPromise) {
    return gtmPromise;
  }

  gtmPromise = new Promise((resolve, reject) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    if (document.getElementById(GTM_SCRIPT_ID)) {
      resolve();
      return;
    }

    const firstScriptTag = document.getElementsByTagName('script')[0];
    const scriptTag = createGTMScriptTag();

    scriptTag.addEventListener('error', (error: Event) => {
      reject(error);
    });
    scriptTag.addEventListener('load', () => {
      resolve();
    });

    firstScriptTag.parentNode?.insertBefore(scriptTag, firstScriptTag);
  });

  return gtmPromise;
};
